import settings from './appSettings.json' with { type: 'json' }

export const APP_SETTINGS = settings

export type AppSettings = typeof APP_SETTINGS
